import { useNavigate } from 'react-router-dom';
import { Calendar, ArrowRight } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { HEADER_SIGNUP_CTA } from '@/lib/marketing-cta';
import { VESTA_BOOK_DEMO_URL } from '@/brand/vesta-cfo-brand';

interface MobileStickyCtaProps {
  /** Hide on pages where a bottom nav already exists */
  hidden?: boolean;
}

export function MobileStickyCta({ hidden = false }: MobileStickyCtaProps) {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  if (hidden || !isMobile) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-vesta-navy/95 px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] backdrop-blur-lg md:hidden"
      role="region"
      aria-label="Quick actions"
    >
      <div className="mx-auto flex max-w-lg gap-2">
        <a
          href={VESTA_BOOK_DEMO_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-1 items-center justify-center gap-2 rounded-full border border-white/20 px-4 py-3 text-xs font-semibold uppercase tracking-wider text-white transition-colors hover:bg-white/5"
        >
          <Calendar className="h-4 w-4" aria-hidden />
          Demo
        </a>
        <button
          type="button"
          onClick={() => navigate('/auth')}
          className="flex flex-[1.2] items-center justify-center gap-2 rounded-full bg-vesta-gold px-4 py-3 text-xs font-semibold uppercase tracking-wider text-vesta-navy transition-colors hover:bg-vesta-gold/90"
        >
          {HEADER_SIGNUP_CTA}
          <ArrowRight className="h-4 w-4" aria-hidden />
        </button>
      </div>
    </div>
  );
}
